import type { InferOutput } from "valibot";

export const phoneSchema = v.object({
  number: v.string(),
  country: v.string(),
  national: v.string(),
  international: v.string(),
});
export type Phone = InferOutput<typeof phoneSchema>;
